import { Divider as MuiDivider } from "@mui/material";
import { Box } from "@mui/material";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
import { LeftSidebar as NavFrame } from "layout-blueprints";
import { getByUnitUuid as getMetersByUnitUuid } from "../../modules/meter/api/actions";
import MeterTable from "../../modules/meter/components/Table";
import { get as getOwners } from "../../modules/owner/api/actions";
import {
  get as getPropertyManagers,
  getById as getPropertyManagerById,
} from "../../modules/propertyManager/api/actions";
import PropertyManagerDetailCard from "../../modules/propertyManager/components/DetailCard";
import { get as getPropertyManagerStatuses } from "../../modules/propertyManagerStatus/api/actions";
import { getByUuid as getUnitByUuid, getUnitAllOccupants } from "../../modules/unit/api/actions";
import UnitDetailCard from "../../modules/unit/components/DetailCard";
import { get as getUnitTypes } from "../../modules/unitType/api/actions";
import ToolBar from "./ToolBar";
import OccupantsTable from "modules/unit/components/OccupantsTable";

const Divider = styled(MuiDivider)(spacing);
const IndividualUnitPage = (props) => {
  const params = useParams();
  const unitUuid = params.uuid;
  const propertyManagerId = params.propertyManagerId;

  const onUpdateMeters = () => {
    const unitUuid = params.uuid;
    props.getMetersByUnitUuid(unitUuid);
  };

  const refreshPage = () => {
    props.getMetersByUnitUuid(unitUuid);
    props.getUnitByUuid(unitUuid).then(() => {
      props.getPropertyManagerById(props.units.data.unit.propertyManagerId);
    });
    props.getPropertyManagers();
    props.getOwners();
    props.getUnitTypes();
    props.getPropertyManagerStatuses();
    props.getUnitAllOccupants(unitUuid, true);
  }

  useEffect(() => {
    refreshPage();
  }, [props.user.data]);


  if (!props.units.data.unit.address2 || !props.units.data.unit.address1) {
    document.title = "Ubil+ Unit";
  }
  else {
    document.title = props.units.data.unit.address2 + " " + props.units.data.unit.address1;
  }

  return (
    //   <NavFrame page={"IndividualPropertyPage"}>
    //   <StandardHeader title="Property Details" />
    //   <MuiDivider my={3} />
    //   <GridLegacy container spacing={2}>
    //     <GridLegacy container item spacing={2}>
    //       <GridLegacy item spacing={2} xs={6}>
    //         <PropertyDetailCard />
    //       </GridLegacy>
    //       <GridLegacy item spacing={2} xs={6}>
    //         <PropertyManagerDetailCard />
    //       </GridLegacy>
    //     </GridLegacy>
    //     <GridLegacy container item spacing={2}>
    //       <GridLegacy item spacing={2} xs={4}>
    //         <PropertyUtilityDetailCard />
    //       </GridLegacy>
    //       <GridLegacy item spacing={2} xs={8}>
    //         <GridLegacy container item spacing={2}>
    //           <GridLegacy item spacing={2} xs={6}>
    //             <UnitCountCard />
    //           </GridLegacy>
    //           <GridLegacy item spacing={2} xs={6}>
    //             <TotalSqFtCard />
    //           </GridLegacy>
    //           <GridLegacy item spacing={2} xs={12}>
    //             <UnitTable />
    //           </GridLegacy>
    //         </GridLegacy>
    //       </GridLegacy>
    //     </GridLegacy>
    //   </GridLegacy>
    // </NavFrame>

    <NavFrame page={"IndividualUnitPage"}>
      <StandardHeader title="Unit Info"
        rightSideToolBar={<ToolBar refreshPage={refreshPage} />}
      />
      <Divider className="mb-3 mt-3" />
      <Box sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
            <UnitDetailCard unitUuid={unitUuid} />
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
            <PropertyManagerDetailCard />
          </Box>
          <Box sx={{ width: '100%' }}>
            <OccupantsTable unitUuid={unitUuid}></OccupantsTable>
          </Box>
          <Box sx={{ width: '100%' }}>
            <MeterTable onUpdate={onUpdateMeters}></MeterTable>
          </Box>
        </Box>
      </Box>
    </NavFrame>
  );
};

IndividualUnitPage.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  units: PropTypes.object.isRequired,
  propertyManagers: PropTypes.object.isRequired,
  getUnitByUuid: PropTypes.func.isRequired,
  getPropertyManagerById: PropTypes.func.isRequired,
  getMetersByUnitUuid: PropTypes.func.isRequired,
  getPropertyManagers: PropTypes.func.isRequired,
  getOwners: PropTypes.func.isRequired,
  getUnitTypes: PropTypes.func.isRequired,
  getPropertyManagerStatuses: PropTypes.func.isRequired,
  getUnitAllOccupants: PropTypes.func.isRequired
};

// Component State
function IndividualUnitPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    units: state.units,
    owners: state.owners,
    unitTypes: state.unitTypes,
    propertyManagers: state.propertyManagers
  };
}

export default connect(IndividualUnitPageState, {
  getMetersByUnitUuid,
  getUnitByUuid,
  getPropertyManagerById,
  getPropertyManagers,
  getOwners,
  getUnitTypes,
  getPropertyManagerStatuses,
  getUnitAllOccupants
})(IndividualUnitPage);
